module.exports = __webpack_public_path__ + "static/media/Professional.b28faed1.jpg";